import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { mediaUrl } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { ZAR } from "@/lib/cart";
import usePageMeta from "@/lib/useSeo";
import { Heart, Trash } from "@phosphor-icons/react";

export default function Wishlist() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  usePageMeta({ title: "Your Wishlist · Vape Essence" });

  const load = () => {
    if (!user) return;
    api.get("/wishlist/mine").then((r) => setItems(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, [user]);

  const remove = async (slug) => {
    await api.delete(`/wishlist/${slug}`);
    toast.success("Removed from wishlist");
    load();
  };

  if (!user) {
    return (
      <div className="mx-auto max-w-[600px] px-6 py-32 text-center lg:px-10">
        <Heart size={40} weight="duotone" className="mx-auto text-[#FF5A1F]" />
        <h1 className="mt-6 font-display text-4xl font-black tracking-tighter">Sign in to see your wishlist</h1>
        <Link to="/account" className="mt-8 inline-block bg-[#FF5A1F] px-6 py-3 font-label text-xs text-black">
          Sign in
        </Link>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-[1200px] px-6 py-16 lg:px-10">
      <div className="font-label text-xs text-[#FF5A1F]">/ WISHLIST</div>
      <h1 className="mt-3 font-display text-5xl font-black tracking-tighter">Saved for later.</h1>
      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {items.length === 0 && (
          <div className="col-span-full py-16 text-center text-sm text-white/40">
            Nothing saved yet. Tap the heart on any product to add it here.
          </div>
        )}
        {items.map((w) => (
          w.product && (
            <div key={w.product.slug} className="group relative border border-white/10 bg-[#0d0d0d]">
              <button
                onClick={() => remove(w.product.slug)}
                className="absolute right-2 top-2 z-10 inline-flex items-center justify-center h-8 w-8 border border-white/15 bg-black/70 text-white/60 hover:text-[#FF5A1F] hover:border-[#FF5A1F] transition-colors"
              >
                <Trash size={14} />
              </button>
              <Link to={`/product/${w.product.slug}`}>
                <div className="aspect-[4/5] overflow-hidden bg-black">
                  {w.product.images?.[0] && (
                    <img src={mediaUrl(w.product.images[0])} alt="" className="h-full w-full object-cover" />
                  )}
                </div>
                <div className="p-4">
                  <div className="font-label text-[10px] text-white/40">{w.product.brand}</div>
                  <div className="mt-1 font-display text-sm font-bold line-clamp-1">{w.product.name}</div>
                  <div className="mt-2 text-[#00FFC2] font-display font-bold">{ZAR(w.product.price)}</div>
                </div>
              </Link>
            </div>
          )
        ))}
      </div>
    </div>
  );
}
